// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7fe0b518","239":"1a62a482","453":"c271584c","667":"e6146254"}[chunkId] + ".chunk.js";
};